<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="clearfix container-top">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item to="/sys/user">用户管理</el-breadcrumb-item>
          <el-breadcrumb-item>用户权限配置</el-breadcrumb-item>
        </el-breadcrumb>
        <el-button size="small" type="primary" @click="customPermiss">特殊权限权限</el-button>
      </div>
      <el-descriptions>
        <el-descriptions-item label="用户名称">{{ itemInfo.username }}</el-descriptions-item>
        <el-descriptions-item label="联系方式">{{ itemInfo.userMobile }}</el-descriptions-item>
        <el-descriptions-item label="性别">
          <span v-if="itemInfo.userSex == 0">女</span>
          <span v-if="itemInfo.userSex == 1">男</span>
        </el-descriptions-item>
        <el-descriptions-item label="邮箱">{{ itemInfo.userEmail }}</el-descriptions-item>
        <el-descriptions-item label="系统" v-if="itemInfo.companyList">{{ itemInfo.companyList[0].companyName }}</el-descriptions-item>
        <el-descriptions-item label="部门">{{ itemInfo.groupName }}</el-descriptions-item>
        <el-descriptions-item label="岗位">{{ itemInfo.positionName }}</el-descriptions-item>
        <el-descriptions-item label="用户状态">
          <el-tag size="small" type="success" v-if="itemInfo.userStatus == 0">开启</el-tag>
          <el-tag size="small" type="danger" v-if="itemInfo.userStatus == 1">关闭</el-tag>
        </el-descriptions-item>
      </el-descriptions>
    </el-card>
    <el-card class="box-card" style="margin-top: 10px;">
      <el-row :gutter="24">
        <el-col :span="8">
          <h6 style="height: 40px;">系统</h6>
          <el-card style="height: 400px;">
            <el-tree
              ref="tree"
              :data="companyList"
              highlight-current
              accordion
              show-checkbox
              check-strictly
              node-key="companyId"
              @check="checkChange"
              :props="companyProps">
            </el-tree>
          </el-card>
        </el-col>
        <el-col :span="16">
          <h6 style="height: 40px;">角色</h6>
          <el-card style="height: 400px;">
            <el-transfer
              v-model="value"
              :titles="['未拥有角色', '已拥有角色']"
              :props="{
                key: 'roleId',
                label: 'roleName'
              }"
              :left-default-checked="unRoleList"
              :data="roleList"
              @change="handleChange"
            >
            </el-transfer>
          </el-card>
        </el-col>
      </el-row>
      <div class="footer-btn">
        <el-button size="small" type="danger" @click="$router.back()">取 消</el-button>
        <el-button size="small" type="success" @click="changeUserInfo">保 存</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import { getAllCompanyList, getAllRoleForCompany, getUserInfoForCompanyId, changeUserRole } from '@/api/usermange';
export default {
  name: 'PermissionConfig',
  data () {
    return {
      itemInfo: {},
      companyProps: {
        children: 'children',
        label: 'companyName'
      },
      companyList: [],
      roleList: [],
      unRoleList: [],
      value: [],
      companyIds: '',
      selectRoleList: []
    };
  },
  watch: {
    companyIds(newVal, oldVal){
      if(newVal){
        this.getAllRoleList()
      }
    },
  },
  beforeMount() {
    this.getUserDataInfo()
    this.getUserItemInfo()
  },

  methods: {
    // 根据用户ID查询用户信息
    async getUserDataInfo(){
      const res = await getUserInfoForCompanyId(this.$route.query.id);
      if(res.code === '200'){
        this.itemInfo = res.data
        this.unRoleList = res.data.roleArray
      }else{
        this.$message.error(res.msg)
      }
    },
    // 获取用户权限
    async getUserItemInfo(){
      const that = this;
      let arr = [];
      const res = await getAllCompanyList();
      if(res.code === '200'){
        that.companyList = res.data
        if(this.itemInfo.companyList.length > 0){
          this.itemInfo.companyList.forEach(item => {
            arr.push(item.companyId)
          })
        }
        this.$nextTick(function(){
          that.$refs.tree.setCheckedKeys(arr)
        })
      }else{
        this.$$message.error(res.msg)
      }
    },
    // 根据系统ID查询所有角色信息
    async getAllRoleList(){
      const res = await getAllRoleForCompany(this.companyIds);
      if(res.code === '200'){
        this.roleList= res.data
        this.roleList.forEach(item => {
          this.itemInfo.roleArray.forEach(value => {
            if(value == item.roleId){
              this.value.push(item.roleId)
            }
          })
        })
      }else{
        this.$message.error(res.msg)
      }
    },
    // 选择的角色
    handleChange(value){
      this.selectRoleList = value
    },
    checkChange(data, checked, node){
      this.companyIds = data.companyId
      if(checked){
        this.$refs.tree.setCheckedNodes([data])
      }
    },
    // 确定修改
    async changeUserInfo(){
      let params = {
        userId: this.$route.query.id,
        roleArray: this.selectRoleList
      }
      const res = await changeUserRole(params)
      if(res.code === '200'){
        this.$message.success('修改成功')
        this.$router.back()
      }else{
        this.$message.error(res.msg)
      }
    },
    // 自定义用户权限
    customPermiss(){
      this.$router.push({
        path: '/sys/user/custompermission',
        query: {
          id: this.$route.query.id
        }
      })
    }
  }

}

</script>
<style lang='scss' scoped>
.container-top{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.footer-btn{
  text-align: center;
  margin: 40px 0 10px;
}
</style>